import React, { FC } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import HTMLReactParserSafe from '../../partials/html-react-parser-safe';

interface Props {
  breedsFaqArray: ({question: string, answer: string})[] | null;
}

const BreedFaq: FC<Props> = ({ breedsFaqArray }) => {
  if (!breedsFaqArray || !breedsFaqArray.length) return null;

  return (
    <section className="breed-faq breed-faq-wrapper">
      <div className="container">
        <h2 className="breed-faq-title">FAQs</h2>
        <div className="mt-2">
          {breedsFaqArray.map(({ question, answer }, index) => (
            <Accordion key={question}>
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} className="breed-faq-icon" />}
              >
                <h3 className="breed-faq-question">
                  {question}
                </h3>
              </AccordionSummary>
              <AccordionDetails>
                <HTMLReactParserSafe html={answer} />
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BreedFaq;
